// extracted by mini-css-extract-plugin
export default {"main":"CustomerScreen_main__-m4Xa","body":"CustomerScreen_body__BTwBZ"};